import Vue from 'vue';
import Router from 'vue-router';
Vue.use(Router)

export default new Router({
    routes: [{
        path: '/Login',
        component: resolve => require(['@/page/Login.vue'], resolve),
    }, {
        path: '/',
        component: resolve => require(['@/page/index.vue'], resolve),
    },
    {
        path: '/index',
        component: resolve => require(['@/page/index.vue'], resolve),
        redirect: '/user_management/user_list',
        children: [
            // 设置
            {
                path: '/set_up/add_menu',
                component: resolve => require(['@/page/set_up/add_menu.vue'], resolve)
            },
            {
                path: '/set_up/menu_list',
                component: resolve => require(['@/page/set_up/menu_list.vue'], resolve)
            },
            {
                path: '/set_up/add_role',
                component: resolve => require(['@/page/set_up/add_role.vue'], resolve)
            },
            {
                path: '/set_up/role_list',
                component: resolve => require(['@/page/set_up/role_list.vue'], resolve)
            },
            {
                path: '/set_up/user_list',
                component: resolve => require(['@/page/set_up/user_list.vue'], resolve)
            },
            {
                path: '/set_up/addStaff',
                component: resolve => require(['@/page/set_up/addStaff.vue'], resolve)
            },
            //店铺管理
            {
                path: '/shop_manage/industry_list',
                component: resolve => require(['@/page/shop_manage/industry_list.vue'], resolve)
            }, // 行业分类
            {
                path: '/shop_manage/industry_add',
                component: resolve => require(['@/page/shop_manage/industry_add.vue'], resolve)
            }, //添加行业分类
            {
                path: '/shop_manage/case_manage',
                component: resolve => require(['@/page/shop_manage/case_manage.vue'], resolve)
            }, // 模板列表
            {
                path: '/shop_manage/case_detail',
                component: resolve => require(['@/page/shop_manage/case_detail.vue'], resolve)
            }, // 模板详情
            {
                path: '/shop_manage/case_menu_list',
                component: resolve => require(['@/page/shop_manage/case_menu_list.vue'], resolve)
            }, // 添加模板
            {
                path: '/shop_manage/case_menu_add',
                component: resolve => require(['@/page/shop_manage/case_menu_add.vue'], resolve)
            }, // 添加模板

            // 课程
            {
                path: '/course/course_mge',
                component: resolve => require(['@/page/course/course_mge.vue'], resolve)
            },  //课程管理
            {
                path: '/course/course_add',
                component: resolve => require(['@/page/course/course_add.vue'], resolve)
            }, //添加课程管理
            {
                path: '/course/chapter_mge',
                component: resolve => require(['@/page/course/chapter_mge.vue'], resolve)
            },  //章节管理
            {
                path: '/course/chapter_add',
                component: resolve => require(['@/page/course/chapter_add.vue'], resolve)
            }, //添加章节管理
            {
                path: '/course/courseware_mge',
                component: resolve => require(['@/page/course/courseware_mge.vue'], resolve)
            },  //课件管理
            {
                path: '/course/courseware_add',
                component: resolve => require(['@/page/course/courseware_add.vue'], resolve)
            }, //添加课件管理
            {
                path: '/course/video_mge',
                component: resolve => require(['@/page/course/video_mge.vue'], resolve)
            },  //视频管理
            {
                path: '/course/video_add',
                component: resolve => require(['@/page/course/video_add.vue'], resolve)
            }, //添加视频管理
            {
                path: '/course/video_detail',
                component: resolve => require(['@/page/course/video_detail.vue'], resolve)
            }, //添加视频管理


            // 用户管理
            {
                path: '/user_management/user_list',
                component: resolve => require(['@/page/user_management/user_list.vue'], resolve)
            }, //用户管理
            {
                path: '/user_management/user_detail',
                component: resolve => require(['@/page/user_management/user_detail.vue'], resolve)
            }, //用户详情
            {
                path: '/user_management/user_add',
                component: resolve => require(['@/page/user_management/user_add.vue'], resolve)
            }, //添加用户
            {
                path: '/user_management/custom_user',
                name: '定制客户',
                component: resolve => require(['@/page/user_management/custom_user.vue'], resolve)
            },
            {
                path: '/user_management/customer_list',
                name: '定制客户2',
                component: resolve => require(['@/page/user_management/customer_list.vue'], resolve)
            },
            {
                path: '/user_management/customer_detail',
                name: '定制详情',
                component: resolve => require(['@/page/user_management/customer_detail.vue'], resolve)
            },
            {
                path: '/user_management/customer_modify',
                name: '定制客户-修改',
                component: resolve => require(['@/page/user_management/customer_modify.vue'], resolve)
            },
            {
                path: '/user_management/customer_add',
                name: '定制客户-添加',
                component: resolve => require(['@/page/user_management/customer_add.vue'], resolve)
            },


            //平台管理
            {
                path: '/platform_manage/behavior_log',
                component: resolve => require(['@/page/platform_manage/behavior_log.vue'], resolve)
            }, //行为日志
            {
                path: '/platform_manage/behavior_type',
                component: resolve => require(['@/page/platform_manage/behavior_type.vue'], resolve)
            }, //合同管理
            {
                path: '/platform_manage/behavior_add',
                component: resolve => require(['@/page/platform_manage/behavior_add.vue'], resolve)
            }, //添加合同
            {
                path: '/platform_manage/channel_management',
                component: resolve => require(['@/page/platform_manage/channel_management.vue'], resolve)
            }, //渠道管理
            {
                path: '/platform_manage/channel_add',
                component: resolve => require(['@/page/platform_manage/channel_add.vue'], resolve)
            }, //渠道管理添加/修改

            {
                path: '/template/index',
                component: resolve => require(['@/page/template/index.vue'], resolve)
            },  // 应用模版
            {
                path: '/template/add',
                component: resolve => require(['@/page/template/add.vue'], resolve)
            },  // 添加 - 应用模版

            {
                path: '/template/version_list',
                component: resolve => require(['@/page/template/version_list.vue'], resolve)
            },  // 版本价格
            {
                path: '/template/version_add',
                component: resolve => require(['@/page/template/version_add.vue'], resolve)
            },  // 添加 - 版本价格
        ]
    },
    ],
    scrollBehavior(to, from, savedPosition) {
        return {
            x: 0,
            y: 0
        }
    }
})



// WEBPACK FOOTER //
// ./src/router/index.js